import draggable from 'vuedraggable'
import { mapGetters } from 'vuex'
import IntentPrefill from './IntentPrefill'
import IntentText from './IntentText'

import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'
import MessageViewer from '@/components/elements/MessageViewer'
import ModalDialog from '@/components/elements/ModalDialog'
import MoveVertical from '@/components/elements/MoveVertical'
import specialtext from '@/components/elements/specialtext'
import StickerList from '@/components/elements/StickerList'
import uploadfile from '@/components/elements/uploadfile'
import ViewCartSummaryViewer from '@/components/elements/ViewCartSummaryViewer'
import ViewCartSummaryViewer2 from '@/components/elements/ViewCartSummaryViewer2'
import AddGenericButton from '@/components/view/chatbot/AddGenericButton'
import IntentGetstarted from '@/components/view/intent/IntentGetstarted'
import moment from 'moment'
import IntentCartAddRemove from './IntentCartAddRemove'
import IntentGbPrime from './IntentGbPrime'
import IntentGenericManage from './IntentGenericManage'
import IntentLineFlex from './IntentLineFlex'
import IntentLineFlexMessage from './IntentLineFlexMessage'
import IntentLineImageMap from './IntentLineImageMap'
import IntentLineImageMapMessage from './IntentLineImageMapMessage'
import IntentTreeView from './IntentTreeView'
import IntentNtnManage from './IntentNtnManage'
import ModalVideo from './ModalVideo'
import ModalMetaPay from './ModalMetaPay'
import { PAGE } from '@/constants/page.js'

export default {
  props: {
    value: {},
    intentname: {},
    isWelcome: {},
    indexAlternative: {},
    channel: {},
    maxIntent: {
      default: 10
    },
    availableBubbles: {},
    sendType: null,
    isBeacon: {
      dafault: false,
      type: Boolean
    },
    inactiveTextBubble: {
      dafault: false,
      type: Boolean
    },
    isFirstAnnouncement: {
      default: false,
      type: Boolean
    }
  },
  inject: ['$validator'],
  data: function () {
    return {
      dialog: {
        addPayment: false,
        editPayment: false
      },
      showCartaddremoveTemp: '',
      bubbleMessages: this.value,
      newButton: {
        title: '',
        type: 'web_url',
        url: ''
      },
      showVideo: false,
      showLineFlex: false,
      showRichMessage: false,
      showLineImageMap: false,
      showTreeView: false,
      showLineSticker: false,
      flexMessage: undefined,
      imageMap: undefined,
      treeView: undefined,
      showCartaddremove: false,
      editTimestamp: moment().format('x'),
      saveTimestamp: moment().format('x'),
      countMenulist: 0,
      showGBPrimePayment: false,
      reRenderKey: 0,
      metaPayDialog: false,
      valueMetaPay: null
    }
  },
  components: {
    IntentText,
    draggable,
    IntentPrefill,
    IntentLineImageMapMessage,

    ModalDialog,
    specialtext,
    uploadfile,
    MoveVertical,
    AutoresizeTextarea,
    AddGenericButton,
    IntentGenericManage,
    IntentNtnManage,
    IntentGetstarted,
    MessageViewer,
    ViewCartSummaryViewer,
    ViewCartSummaryViewer2,
    ModalVideo,
    IntentLineFlexMessage,
    IntentLineFlex,
    IntentGbPrime,
    IntentCartAddRemove,
    IntentLineImageMap,
    StickerList,
    IntentTreeView,
    // Modal2,
    ModalMetaPay
  },
  computed: {
    isDDProperty() {
      if (this.selectedBot) {
        if (PAGE.DDPROPERTY.includes(this.selectedBot.pageid)) {
          return true
        }
      }
      return false
    },
    addLimit() {
      if (this.isFirstAnnouncement) {
        return 3
      } else if (this.isBeacon) {
        return 5
      } else {
        return this.maxIntent ? this.maxIntent : 10
      }
    },
    activeBubbles() {
      const list = this.availableBubbles
        ? this.availableBubbles
        : this.$store.state.defaultBubbleList

      if (this.isFirstAnnouncement) {
        return list.filter((el) =>
          ['text', 'button', 'image', 'generic', 'video', 'line_flex', 'line_imagemap'].includes(el)
        )
      }

      if (this.isDDProperty) {
        return list.filter((el) => {
          return !['payment_form', 'add_cart'].includes(el)
        })
      } else if (['amaze'].includes(this.selectedBot.type)) {
        return list.filter((el) => {
          return ['text', 'button', 'image', 'generic', 'welcome_message', 'tree_view'].includes(el)
        })
      }
      return list
    },
    hasAloneIntent() {
      return this.value.some((el) => {
        return ['removeandaddtocart', 'addtocart', 'removetocart', 'payment', 'meta_pay'].includes(
          el.type
        )
      })
    },
    inactiveAloneIntent() {
      var vm = this
      return vm.bubbleCount >= vm.maxIntent || vm.bubbleCount > 0
    },
    hasAloneIntentTooltips() {
      if (
        this.value.some((el) => {
          return ['removeandaddtocart', 'addtocart', 'removetocart'].includes(el.type)
        })
      ) {
        return this.$t('Choosing Add/Remove to cart function, the item can be used only one alone.')
      } else {
        return this.$t('Choosing GB Prime Payment function, the item can be used only one alone.')
      }
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      products: 'getProducts',
      welcomeMessage: 'welcomeMessage',
      isCoachlab: 'isCoachlab'
    }),
    bubbleCount: function () {
      var vm = this

      if (vm.bubbleMessages) {
        var count = 0
        vm.countMenulist = 0
        vm.bubbleMessages.map((bubble) => {
          if (bubble.type == 'generic') {
            vm.countMenulist++
          }
          if (bubble.type == 'welcome_message') {
            if (vm.welcomeMessage && vm.welcomeMessage.messages && vm.welcomeMessage.messages[0]) {
              count += vm.welcomeMessage.messages[0].length
            } else {
              count++
            }
          } else {
            count++
          }
        })
        return count
      } else {
        return 0
      }
    },
    activeBubbleTreeView() {
      return ['amaze'].includes(this.selectedBot.type)
    },
    isThailandPostMart() {
      return ['thailandpostmart'].includes(this.selectedBot.type)
    }
  },
  mounted: function () {
    this.resetFlexMessage()
    window.addEventListener(
      'message',
      (e) => {
        if (e.data) {
          this.handleListenEventMessage(e.data)
        }
      },
      false
    )
  },
  beforeDestroy() {
    window.removeEventListener(
      'message',
      (e) => {
        if (e.data) {
          this.handleListenEventMessage(e.data)
        }
      },
      false
    )
  },
  methods: {
    handleListenEventMessage({ event_id, data }) {
      switch (event_id) {
        case 'zwiz-line-image-map-create':
          this.imageMap = JSON.stringify(data)
          this.saveAddImageMap()
          break
        case 'zwiz-line-image-map-cancel':
          this.showLineImageMap = false
          break
        case 'zwiz-tree-view-create':
          this.treeView = JSON.stringify(data)
          this.saveAddTreeView()
          break
        case 'zwiz-tree-view-cancel':
          this.showTreeView = false
          break
      }
    },
    addSticker({ packageid, stickerid }) {
      this.bubbleMessages.push({
        packageid: packageid,
        stickerid: stickerid,
        type: 'sticker'
      })
    },
    changeRatio(index, payload) {
      this.$set(
        this.bubbleMessages[index],
        'ratio',
        payload == 'horizontal' ? 'horizontal' : 'square'
      )
    },
    cancelAddImageMap() {
      this.showLineImageMap = false
      this.showRichMessage = false
      this.resetImageMap()
    },
    saveAddImageMap() {
      var vm = this
      var imagemap = null

      try {
        imagemap = JSON.parse(vm.imageMap)
        var type = imagemap.type == 'basicimagemap' ? 'basicimagemap' : 'imagemap'
        vm.bubbleMessages.push({
          ...imagemap,
          type
        })
        vm.$emit('input', vm.bubbleMessages)
      } catch (error) {
        console.log(error)
      }
      vm.showLineImageMap = false
      vm.showRichMessage = false
      vm.resetImageMap()
    },
    resetImageMap() {
      this.imageMap = '{}'
    },
    cancelAddTreeView() {
      this.showTreeView = false
      this.resetTreeView()
    },
    saveAddTreeView() {
      const vm = this
      let tempTreeView = null

      try {
        tempTreeView = JSON.parse(vm.treeView)
        vm.bubbleMessages.push({
          ...tempTreeView,
          type: 'tree_view'
        })
        vm.$emit('input', vm.bubbleMessages)
      } catch (error) {
        console.log(error)
      }
      vm.showTreeView = false
      vm.resetTreeView()
    },
    resetTreeView() {
      this.treeView = '{}'
    },
    closecartaddremove() {
      this.showCartaddremove = false
    },
    cartaddremove() {
      var vm = this
      if (vm.bubbleCount < vm.maxIntent && vm.bubbleCount <= 0) {
        this.showCartaddremoveTemp = ''
        this.showCartaddremove = true
      }
    },
    editRemoveAndAdd(item, index) {
      this.showCartaddremoveTemp = {
        input: [...item.data],
        type: item.type,
        index,
        checksameproductincarts: item.checksameproductincarts,
        checkstock: item.checkstock,
        adjuststock: item.adjuststock
      }

      this.showCartaddremove = true
    },
    updateRemoveAndAdd(obj) {
      if (this.isThailandPostMart) {
        Object.assign(this.bubbleMessages[obj.index], {
          data: obj.data,
          text: {
            addtocart: '{thailandpostmart_add_cart}',
            removetocart: '{thailandpostmart_remove_cart}',
            removeandaddtocart: '{thailandpostmart_checkout_cart}'
          }[obj.type],
          type: obj.type,
          checkstock: obj.checkstock,
          checksameproductincarts: obj.checksameproductincarts,
          adjuststock: obj.adjuststock
        })
      } else {
        const mytext = obj.data.map(
          (el) => `{"pid":${el.pid},"qty":${el.qty},"option":"${el.option}"}`
        )
        Object.assign(this.bubbleMessages[obj.index], {
          data: obj.data,
          text: `{${obj.type}([${mytext}])}`,
          type: obj.type,
          checkstock: obj.checkstock,
          checksameproductincarts: obj.checksameproductincarts,
          adjuststock: obj.adjuststock
        })
      }
    },
    metaPayForm(item, index) {
      const vm = this
      if (
        (vm.bubbleCount < vm.addLimit && !vm.hasNtnIntent && !['google'].includes(vm.channel)) ||
        typeof index !== 'undefined'
      ) {
        if (this.$store.getters.getPackage != 'normal' && !this.isBroadCast) {
          let input = {
            type: 'meta_pay',
            detail: '',
            amount: '',
            note: '',
            is_create_order: false,
            create: true
          }
          vm.metaPayDialog = true
          vm.valueMetaPay = item && item.amount ? { ...item, index, create: false } : input
        }
      }
    },
    updateMetaPaymentItem(obj) {
      const vm = this
      vm.bubbleMessages[obj.index] = obj
    },
    paymentForm(item, index) {
      var vm = this

      if ((vm.bubbleCount < vm.maxIntent && vm.bubbleCount <= 0) || index || index === 0) {
        let input = {
          detail: '',
          amount: 0,
          delivery: { name: '', code: 0 },
          response: 'จ่ายบิลได้ที่',
          type: 'payprime',
          create: true
        }
        this.$store.commit('modalAssign', {
          component: IntentGbPrime,
          input: item.text ? { ...item.data, index, create: false } : input,
          open: true
        })
      }
      vm.showGBPrimePayment = true
    },
    updatePaymentItem(obj) {
      Object.assign(this.bubbleMessages[obj.index], {
        data: obj,
        text: `{sendgbprimelink(${obj.detail}&&${obj.amount}&&${obj.delivery.code}&&${obj.response})}`
      })
    },
    closeModal() {
      this.dialog = {
        addPayment: false,
        editPayment: false
      }
    },
    cancelAddFlexMessage: function () {
      this.showLineFlex = false
      this.resetFlexMessage()
    },
    saveAddFlexMessage: function () {
      var vm = this
      vm.bubbleMessages.push(vm.flexMessage)
      vm.$emit('input', vm.bubbleMessages)
      vm.showLineFlex = false
      vm.resetFlexMessage()
    },
    resetFlexMessage: function () {
      var altText
      if (this.selectedBot.theme == 'powerbuy') {
        altText = ''
      } else {
        altText = 'You received a message'
      }
      this.flexMessage = {
        type: 'flex',
        altText: altText,
        contents: '{}'
      }
    },
    addVideo: function (video) {
      var vm = this
      vm.bubbleMessages.push(video)
      vm.$emit('input', vm.bubbleMessages)
      vm.showVideo = false
    },
    addIntentItem: function (type, data) {
      var vm = this
      if (vm.bubbleCount >= vm.addLimit || vm.hasAloneIntent) {
        return false
      }
      if (type == 'text') {
        vm.bubbleMessages.push({
          text: '',
          type: type
        })
      } else if (type == 'button') {
        vm.bubbleMessages.push({
          text: '',
          buttons: [],
          type: type
        })
      } else if (type == 'image') {
        vm.bubbleMessages.push({
          image_url: '',
          type: type
        })
      } else if (type == 'meta_pay') {
        vm.bubbleMessages.push({
          type: type,
          detail: data.detail,
          amount: data.amount,
          note: data.note,
          is_create_order: data.is_create_order
        })
      } else if (type == 'payment') {
        console.log('add payment')
        vm.bubbleMessages.push({
          text: `{sendgbprimelink(${data.detail}&&${data.amount}&&${data.delivery.code}&&${data.response})}`,
          data: data,
          type: type
        })
      } else if (['removeandaddtocart', 'addtocart', 'removetocart'].includes(type)) {
        var { obj, checkstock, checksameproductincarts, adjuststock } = data
        if (vm.isThailandPostMart) {
          vm.bubbleMessages.push({
            text: {
              addtocart: '{thailandpostmart_add_cart}',
              removetocart: '{thailandpostmart_remove_cart}',
              removeandaddtocart: '{thailandpostmart_checkout_cart}'
            }[type],
            data: obj,
            type: type,
            checkstock: checkstock,
            checksameproductincarts: checksameproductincarts,
            adjuststock: adjuststock
          })
        } else {
          var mytext = obj.map((el) => `{"pid":${el.pid},"qty":${el.qty},"option":"${el.option}"}`)
          vm.bubbleMessages.push({
            text: `{${type}([${mytext}])}`,
            data: obj,
            type: type,
            checkstock: checkstock,
            checksameproductincarts: checksameproductincarts,
            adjuststock: adjuststock
          })
        }
      } else if (type == 'generic') {
        vm.bubbleMessages.push({
          data: [
            {
              image_url: null,
              title: '',
              subtitle: '',
              buttons: []
            }
          ],
          type: type
        })
      } else if (type == 'welcome_message') {
        vm.bubbleMessages.push({
          type: type
        })
      } else if (type == 'viewsummary') {
        if (vm.products.length == 0) {
          return false
        }
        vm.bubbleMessages.push({
          type: 'text',
          text: '{viewsummary}'
        })
      } else if (type == 'video') {
        vm.showVideo = true
      } else if (
        type == 'line_flex' &&
        vm.$store.getters.getPackage == 'premium' &&
        !vm.isCoachlab
      ) {
        vm.showLineFlex = true
      } else if (type == 'rich_message' && vm.$store.getters.getPackage == 'premium') {
        vm.showRichMessage = true
      } else if (type == 'line_imagemap' && vm.$store.getters.getPackage == 'premium') {
        this.reRenderKey++
        vm.showLineImageMap = true
      } else if (type == 'tree_view') {
        this.reRenderKey++
        vm.showTreeView = true
      } else if (type == 'line_sticker') {
        vm.showLineSticker = true
      } else if (type == 'ntn_template') {
        vm.bubbleMessages.push({
          image_url: null,
          title: '',
          notification_messages_frequency: '',
          type: 'ntn_template'
        })
      }
      vm.$emit('input', vm.bubbleMessages)
    },
    onDelete: function (index) {
      this.bubbleMessages.splice(index, 1)
      this.$emit('input', this.bubbleMessages)
    },
    onMove: function (index, direction) {
      var vm = this
      if (direction == 'up') {
        vm.bubbleMessages.splice(index, 0, vm.bubbleMessages.splice(index - 1, 1)[0])
      } else if (direction == 'down') {
        vm.bubbleMessages.splice(index, 0, vm.bubbleMessages.splice(index + 1, 1)[0])
      }
      vm.$emit('input', vm.bubbleMessages)
    },
    onMoveButton: function (index, direction, item) {
      var vm = this

      if (direction == 'up') {
        item.buttons.splice(index, 0, item.buttons.splice(index - 1, 1)[0])
      } else if (direction == 'down') {
        item.buttons.splice(index, 0, item.buttons.splice(index + 1, 1)[0])
      }

      vm.$emit('input', vm.bubbleMessages)
    },
    addNewButton: function (index, payload) {
      if (this.bubbleMessages[index].buttons.length < 3) {
        if (payload.type == 'web_url') {
          delete payload.payload
        } else if (payload.type == 'postback' || payload.type == 'phone_number') {
          delete payload.url
        }
        this.bubbleMessages[index].buttons.push(payload)
        this.newButton = {
          title: '',
          type: 'web_url',
          url: ''
        }
        this.$emit('input', this.bubbleMessages)
      }
      this.saveTimestamp = moment().format('x')
    },
    editButton: function (index, bindex, payload) {
      if (this.bubbleMessages[index].buttons[bindex]) {
        // this.intentItems[index].value.buttons[index] = payload
        if (payload.type == 'web_url') {
          delete payload.payload
        } else if (payload.type == 'postback' || payload.type == 'phone_number') {
          delete payload.url
        }
        this.$set(this.bubbleMessages[index].buttons, bindex, payload)
        this.$emit('input', this.bubbleMessages)
      }
      this.editTimestamp = moment().format('x')
    },
    deleteButton: function (index, bindex) {
      this.bubbleMessages[index].buttons.splice(bindex, 1)
      this.$emit('input', this.bubbleMessages)
    },
    addIntentPrefill: function (index, subindex, prefill) {
      var vm = this
      let cursorPosition = this.$refs['answer_' + index + '_' + subindex][0].$el.selectionStart

      if (vm.bubbleMessages[subindex].type === 'text') {
        vm.$set(
          vm.bubbleMessages[subindex],
          'text',
          [
            vm.bubbleMessages[subindex].text.slice(0, cursorPosition),
            '{' + prefill + '}',
            vm.bubbleMessages[subindex].text.slice(cursorPosition)
          ].join('')
        )
      } else if (vm.bubbleMessages[subindex].type == 'button') {
        vm.$set(
          vm.bubbleMessages[subindex],
          'text',
          [
            vm.bubbleMessages[subindex].text.slice(0, cursorPosition),
            '{' + prefill + '}',
            vm.bubbleMessages[subindex].text.slice(cursorPosition)
          ].join('')
        )
      }
      this.$emit('input', this.bubbleMessages)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/intent/IntentGroupItem.js